import React, { SVGProps } from 'react'
const SvgSidenavAccountingActive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="evenodd"
      d="M10.75 5.274v10.634c.947-.335 1.807-.544 2.657-.613 1.14-.093 2.215.07 3.413.458.11.036.223.015.308-.043a.256.256 0 0 0 .122-.218V7.75H15A1.75 1.75 0 0 1 13.25 6V4.336c-.71.1-1.493.387-2.5.938Zm-.756 12.448a.793.793 0 0 0 .36-.057c1.276-.523 2.262-.8 3.175-.875.901-.073 1.775.049 2.829.39 1.113.36 2.392-.41 2.392-1.688V6.733l-.169-.207-2.638-3.232-.151-.185-.23-.064a6.591 6.591 0 0 0-1.536-.247c-1.295-.044-2.53.354-4.025 1.177-1.31-.722-2.418-1.122-3.53-1.187-1.221-.072-2.351.265-3.643.833-.99.434-1.578 1.423-1.578 2.463v9.4c0 1.282 1.286 2.051 2.4 1.686 1.06-.347 1.94-.47 2.84-.394.911.076 1.89.358 3.15.886a.794.794 0 0 0 .354.06ZM15 6.25h1.42l-1.483-1.817a5.796 5.796 0 0 0-.187-.041V6c0 .138.112.25.25.25Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavAccountingActive
